import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';

const Insights = () => {
    return (
        <div className="main">
            <div className="main-container">
                <div className="page-header">
                    <InsightsOutlinedIcon />
                    <h1>Inzichten</h1>
                </div>
            </div>
        </div>
    )
}

export default Insights
